"use strict";
// ---------------------------------------------------------------------------
// Feedback — pure URL assembly + context types.
//
// PURE: no IO, no side effects. The app layer gathers the raw facts (resolved
// repo, Loom version, OS, usage counts) and this module turns them into the
// prefilled GitHub issue-form URL. Keeping the assembly here means the CLI, the
// MCP resource, and the extension all build the exact same URL from the same
// rules, and the encoding is unit-testable without touching the filesystem.
// ---------------------------------------------------------------------------
Object.defineProperty(exports, "__esModule", { value: true });
exports.FEEDBACK_REPO = exports.FEEDBACK_TEMPLATE_FILE = void 0;
exports.formatFeedbackEnvironment = formatFeedbackEnvironment;
exports.buildFeedbackUrl = buildFeedbackUrl;
/** Issue-form template filename the central sink repo hosts. */
exports.FEEDBACK_TEMPLATE_FILE = 'feedback.yml';
/**
 * The feedback sink — the sole target. EVERY Loom install (this repo, any
 * end-user project) files feedback into the Loom project's issues, full stop.
 * There is intentionally no override: a user must never be able to point Loom
 * feedback at their own repo, where it would be noise to them and invisible to
 * the maintainer. Reusing this mechanism in a non-Loom tool means changing this
 * constant, nothing else.
 */
exports.FEEDBACK_REPO = 'reslava/loom';
/**
 * Render the snapshot as the human-readable body of the form's `environment`
 * field. Plain text, one fact per line, non-PII.
 */
function formatFeedbackEnvironment(s) {
    return [
        `Loom version: ${s.loomVersion}`,
        `OS: ${s.platform}`,
        `Weaves: ${s.weaveCount}`,
        `Threads: ${s.threadCount}`,
        `Done plans: ${s.donePlanCount}`,
        `Current release: ${s.currentRelease ?? 'n/a'}`,
    ].join('\n');
}
/**
 * Build a prefilled GitHub issue-form URL. Pure. GitHub issue *forms* prefill
 * fields by their YAML `id` via `?<field_id>=<value>` (URL-encoded); here the
 * `environment` textarea id must match the sink repo's form, and `template=`
 * targets the form itself.
 */
function buildFeedbackUrl(params) {
    const base = `https://github.com/${params.repo}/issues/new`;
    const query = new URLSearchParams({
        template: exports.FEEDBACK_TEMPLATE_FILE,
        environment: formatFeedbackEnvironment(params.snapshot),
    });
    return `${base}?${query.toString()}`;
}
